// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Layout from './components/Layout/Container'
import Home from './components/Home/Container'
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import reducers from './reducers'
import axios from 'axios'
import thunk from 'redux-thunk';
import { routes } from './config/routes'
import "./config/i18n";
import "../stylesheets/application.scss"
const csrfToken = document.querySelector('[name=csrf-token]').content
axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken



const store = createStore(reducers, applyMiddleware(thunk))


document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
	  <Provider store={store}>	    
	    <Router>
		    <Switch>
		      <Layout>
			      {routes.map((r) => <Route key={r.name} exact path={r.url} component={r.component} />)}
		      </Layout>
		    </Switch>
	    </Router>
	  </Provider>,
	  document.body.appendChild(document.createElement('div')),
  )
})
